module.exports = __webpack_public_path__ + "h5/img/funv-navc2.24caf0e3.png";